<template>
  <v-container fill-height>
    <FormCreateAccount />
  </v-container>
</template>

<script>
import FormCreateAccount from '../components/FormCreateAccount'

export default {
  name: 'CreateAccount',
  components: { FormCreateAccount },
  data() {
    return {}
  }
}
</script>

<style></style>
